import { useEffect, useState } from "react";
import { FaArrowLeft } from "react-icons/fa";

import { getUserPreferences, readUserApi, updateUserPreferences } from "../Api";

import Sports_Pref_Select from "../components/Sports_Pref_Select";

import AvailabilitySelector from "../availability/Components";
function Preference({ onSavePreferences, onBackWithSave }) {
  const [userPreferences, setUserPreferences] = useState(null);

  const [maxDistance, setMaxDistance] = useState(50);
  const [ageRange, setAgeRange] = useState([18, 35]);

  const [gameType, setGameType] = useState("None");
  const [players, setPlayers] = useState("None");
  const [sport_id, setSport] = useState("None");

  const [location, setLocation] = useState(null);

  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);

  const [genderPreference, setGenderPreference] = useState("any");

  const [saving, setSaving] = useState(false);
  const [saveError, setSaveError] = useState("");
const [userData, setUserData] = useState(null);
  useEffect(() => {
    fetchUserData();
  }, []);

  const fetchUserData = async () => {
    try {


        const user = await readUserApi();
    setUserData(user);

      const data = await getUserPreferences();

      setUserPreferences(data);
      setGameType(data.game_type ?? "None");
      setPlayers(data.player ?? "None");
      setSport(data.sport_name ?? "None");
      setLocation(data.location ?? null);
      if (data.maximum_distance) setMaxDistance(data.maximum_distance);
      if (data.min_age && data.max_age) setAgeRange([data.min_age, data.max_age]);
      setGenderPreference(data.gender_preference ?? "any");

      setLatitude(data.latitude ?? null);
      setLongitude(data.longitude ?? null);
      {/** 
      if (!user.is_subscribed && data.game_type === "ranked") {
      setGameType("unranked"); 
    } */}
    } catch (e) {
      console.error("Failed to fetch user preferences:", e.message || e);
    }
  };

  const normalize = (value, fallback = null) => {
    if (!value || value === "None" || value === "") return fallback;
    return value;
  };

  const isValidPreferences = () => {
    const distanceValid = maxDistance > 0;
    const ageValid =
      ageRange[0] >= 18 &&
      ageRange[1] <= 60 &&
      ageRange[1] > ageRange[0];
    const gameTypeValid = gameType !== "" && gameType !== "None";
    const playersValid = players !== "" && players !== "None";

    return distanceValid && ageValid && gameTypeValid && playersValid;
  };

  const handleSavePreferences = async (prefs) => {
    try {
      const mergedPrefs = {
        latitude: prefs.latitude ?? null,
        longitude: prefs.longitude ?? null,
        maximum_distance: prefs.maximum_distance ?? null,
        min_age: prefs.min_age ?? null,
        max_age: prefs.max_age ?? null,
        game_type: normalize(prefs.game_type),
        player: normalize(prefs.player),
        gender_preference: normalize(prefs.gender_preference, "any"),
      };

      await updateUserPreferences(mergedPrefs);
      await fetchUserData();
    } catch (error) {
      console.error("Failed to save preferences:", error);
      throw error;
    }
  };


  const handleBackClick = async () => {
    if (!isValidPreferences()) {
      setSaveError("Please complete all preferences before proceeding.");
      return;
    }

    setSaving(true);
    setSaveError("");

    try {
      await handleSavePreferences({
        sport_id: sport_id !== "None" ? sport_id : null,
        location: null,
        latitude: latitude ? parseFloat(latitude) : null,
        longitude: longitude ? parseFloat(longitude) : null,
        maximum_distance: maxDistance,
        min_age: ageRange[0],
        max_age: ageRange[1],
        game_type: gameType,
        player: players,
        gender_preference: genderPreference,
      });

      // Immediately go back
      if (onBackWithSave) onBackWithSave();
    } catch (err) {
      setSaveError(err.message || "Failed to save preferences.");
    } finally {
      setSaving(false);
    }
  };



  return (

    <div
      style={{
        // background: "linear-gradient(to bottom, #ffb270, #ff9b54)", // mounted 3D look
        padding: "1rem",
        borderRadius: "0.5rem",
      //  color: "#222121ff",
        boxSizing: "border-box",
        width: "100%", // full width
        maxWidth: "100%", // responsive
        fontWeight: "bold",
        marginBottom: "1rem",
      }}
    >


      <button
        className="btn btn-link text-decoration-none mb-3"
        onClick={handleBackClick}
        disabled={saving || !isValidPreferences()}
        style={{
          color: "#FFFAF0",
          padding: "0.375rem 0.75rem",
        }}
      >
        <FaArrowLeft /> {saving ? "Saving..." : "Save"}
      </button>



      <h4 className="text-center mb-3">Preferences & Location</h4>



      <div className="mb-3">
        <button
          style={{
          //  background: "linear-gradient(to bottom, #e6710cff, #e05e01ff)",
            color: "#201f1fff",
            padding: "0.375rem 0.75rem",
            borderRadius: "0.25rem",
            border: "none",
            cursor: "pointer",
            marginBottom: "0.5rem",
            fontWeight: "bold",
            boxSizing: "border-box",
            transition: "all 0.1s ease",
          }}
          onClick={() => {
            if (!navigator.geolocation) {
              alert("Geolocation not supported.");
              return;
            }

            navigator.geolocation.getCurrentPosition(
              (pos) => {
                setLatitude(pos.coords.latitude.toFixed(6));
                setLongitude(pos.coords.longitude.toFixed(6));
              },
              (err) => {
                if (err.code === err.PERMISSION_DENIED) {
                  // Ask user to enable location in settings
                  const retry = window.confirm(
                    "Location permission denied. Please enable it in your browser or device settings. Retry?"
                  );
                  if (retry) {
                    // Call the function again to re-prompt
                    navigator.geolocation.getCurrentPosition(
                      (pos) => {
                        setLatitude(pos.coords.latitude.toFixed(6));
                        setLongitude(pos.coords.longitude.toFixed(6));
                      },
                      () => alert("Still unable to get location.")
                    );
                  }
                } else {
                  alert("Failed to get location.");
                }
              },
              { enableHighAccuracy: true }
            );
          }}
        >
          📍 Get My Location
        </button>

        <div className="form-group mt-2">
          <label>Location (Place Name)</label>
          <input
            type="text"
            className="form-control"
            value={location || ""}
            readOnly
          //  style={{ backgroundColor: "#e9ecef", cursor: "not-allowed" }}
            placeholder="Location"
          />
        </div>

        <div className="form-group mt-2">
          <label>Latitude</label>
          <input
            type="text"
            className="form-control"
            value={latitude || ""}
            onChange={(e) => setLatitude(e.target.value)}
            placeholder="Latitude"
          />
        </div>

        <div className="form-group mt-2">
          <label>Longitude</label>
          <input
            type="text"
            className="form-control"
            value={longitude || ""}
            onChange={(e) => setLongitude(e.target.value)}
            placeholder="Longitude"
          />
        </div>
      </div>

      <div className="col-md-20">
        {/**Sports selection and pereference */}
        <Sports_Pref_Select />
        <AvailabilitySelector />
      </div>

      <div className="mb-3">
        <label>a
          Max Distance: {maxDistance} km <span className="text-danger">*</span>
        </label>
        <input
          type="range"
          className="form-range"
          min="1"
          max="50"
          value={maxDistance}
          onChange={(e) => setMaxDistance(Math.min(+e.target.value, 50))}
        />
      </div>



      <div className="mb-3">
        <label>
          Age Range: {ageRange[0]} - {ageRange[1]} <span className="text-danger">*</span>
        </label>
        <input
          type="range"
          className="form-range"
          min="18"
          max="60"
          value={ageRange[0]}
          onChange={(e) =>
            setAgeRange([+e.target.value, Math.max(+e.target.value, ageRange[1])])
          }
        />
        <input
          type="range"
          className="form-range"
          min="18"
          max="60"
          value={ageRange[1]}
          onChange={(e) =>
            setAgeRange([Math.min(ageRange[0], +e.target.value), +e.target.value])
          }
        />
      </div>

      <div className="mb-3">
        <label>Gender Preference</label>
        <select
          className="form-select"
          value={genderPreference}
          onChange={(e) => setGenderPreference(e.target.value)}
        >
          <option value="any">Any</option>
          <option value="male">Male</option>
          <option value="female">Female</option>
        </select>
      </div>

      <div className="mb-3">
        <label>
          Game Type <span className="text-danger">*</span>
        </label>
      <select
  value={gameType}
  onChange={(e) => setGameType(e.target.value)}
  className="form-select"
>
 {/** disabled={!userData.is_subscribed} */}
 {userData ? (
  
    <>
      <option value="">Select Game Type</option>
      <option value="ranked" >Ranked</option>
      <option value="unranked">Unranked</option>
    </>
  ) : null}


</select>
      </div>

      <div className="mb-3">
        <label>
          Players <span className="text-danger">*</span>
        </label>
        <select
          className="form-select"
          value={players}
          onChange={(e) => setPlayers(e.target.value)}
        >
          <option value="">Select Players</option>
          {["1v1", "2v2", "3v3", "4v4", "5v5"].map((p) => (
            <option key={p} value={p}>
              {p}
            </option>
          ))}
        </select>
      </div>

      {saveError && (
        <div className="text-danger text-center mt-2">{saveError}</div>
      )}   {/* Disclaimer */}
      <div
        style={{
          marginTop: "1rem",
          fontSize: "0.85rem",
       //   color: "#6c757d",
          textAlign: "center",
        }}
      >
        By saving new preferences, you agree that any match searching will be erased.
      </div>
    </div>




  );
}

export default Preference;
